export default __webpack_public_path__ + "static/media/photo-album.12870fcd.jpg";